import { forwardRef, ReactNode, Ref, useRef } from 'react'
import clsx from 'clsx'
import { useElementScrollInit } from 'components/ElementScroll'
import styles from './Page.module.scss'

export type PageProps = {
  children?: ReactNode
  className?: string
  contentClassName?: string
}

const Page = (props: PageProps, ref: Ref<any>) => {
  const { children, className, contentClassName } = props
  const pageRef = useRef<HTMLElement | null>(null)
  const pageRefAdjusted = ref || pageRef

  useElementScrollInit('Page', pageRefAdjusted)

  return (
    <div className={clsx(styles.Page, className)} ref={pageRefAdjusted}>
      <div className={clsx(styles.PageContent, contentClassName)}>{children}</div>
    </div>
  )
}

export default forwardRef(Page)
